<template>
  <div v-if="negociacao.produtos.length">
    <v-row class="mt-1 mb-1" dense v-if="negociacao.produtos.length">
      <v-col cols="12">
        <v-subheader class="body-1 grey lighten-4 text--primary">
          <v-icon>
            mdi-package-variant
          </v-icon>
          <span class="ml-2">Produtos</span>
        </v-subheader>
      </v-col>
    </v-row>
    <v-row class="mb-1" dense v-if="hasDescontoSolicitadoComprador">
      <v-col cols="12">
        Atenção: O comprador solicitou um percentual de desconto.
        Clique no botão abaixo para aplicar o desconto a todos os produtos.
      </v-col>
    </v-row>
    <v-row class="mb-1" dense>
      <v-col class="d-flex align-center" cols="12">
        <px-input-percentual input-class="rounded-tag-small"
                             show-suffix
                             label="Desconto Global"
                             dense
                             v-model="negociacao.percentualDesconto"/>
        <v-btn color="primary"
               outlined
               class="normal-btn-text rounded-tag-small elevation-0 mt-1 ml-1 mb-1 mr-1"
               @click="aplicarDesconto">
          <px-span-tooltip
              top
              text="Aplicar desconto"
              tooltip="Aplicar desconto ao preço unitário de todos os produtos na negociação"/>
        </v-btn>
      </v-col>
    </v-row>
    <v-card v-if="negociacao.produtos.length"
            outlined
            class="rounded-card">
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <px-negociacao-alterar-resposta-produto-row
              v-for="(produto, index) in negociacao.produtos"
              ref="negociacaoProduto"
              :key="produto.id"
              :produto="produto"
              :moeda="resposta.moeda"
              :upload-file-path="uploadFilePath"
              :download-file-path="downloadFilePath"
              :show-divider="showDivider(index)"/>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import { TipoNegociacao } from 'px-business-components';
import NegociacaoAlterarRespostaProdutoRow from './NegociacaoAlterarRespostaProdutoRow.vue';
import { aplicarDescontoAosProdutos } from '../negociacao-utils';

export default {
  data() {
    return {
      refs_children: [],
    };
  },
  props: {
    negociacao: Object,
    resposta: {
      type: Object,
      required: true,
    },
    uploadFilePath: String,
    hasDescontoSolicitadoComprador: Boolean,
  },
  computed: {
    isInvalid() {
      const hasInvalidForms = this.refs_children.some((child) => child.$v.$invalid);
      const hasFilesUploading = this.refs_children.some((child) => child.hasFileLoading);
      if (hasFilesUploading) {
        this.$toast('Aguarde a finalização do envio do(s) arquivo(s)', { color: 'error' });
        return hasFilesUploading;
      }
      return hasInvalidForms;
    },
    isFornecedor() {
      return this.negociacao.tipo === TipoNegociacao.keys.RESPOSTA.key;
    },
    downloadFilePath() {
      if (this.isFornecedor) {
        return `fornecedor/negociacoes/${this.cotacaoId}/download-fornecedor`;
      }
      return `fornecedor/negociacoes/${this.cotacaoId}/download-comprador`;
    },
    showDivider() {
      return (index) => index !== (this.negociacao.produtos.length - 1);
    },
  },
  methods: {
    validate() {
      return this.isInvalid;
    },
    aplicarDesconto() {
      this.negociacao.produtos = aplicarDescontoAosProdutos(
        this.negociacao,
        this.resposta.produtos,
      );
      this.negociacao.$$descontoAplicado = true;
    },
  },
  mounted() {
    this.refs_children = this.$refs.negociacaoProduto;
  },
  components: {
    pxNegociacaoAlterarRespostaProdutoRow: NegociacaoAlterarRespostaProdutoRow,
  },
};
</script>
